import { useState, JSX } from "react";
import styles from "../assets/style.module.css";
import { ApiResponseData, IHostWebsite, IHostBlogArticle, OmneHostService, SanitizedResponse, BaseService, IHostBlogCategory } from "../../../../services";
import React from "react";
import { Classname, Paginator, Scheme, useSearchParams } from "@rivtn/noseur";
import { Utils } from "../../../../utils";


// ─── BLOG DETAIL ──────────────────────────────────────────────────────────────
interface BlogDetailProps {
    onBack: () => void;
    category?: string;
    article: IHostBlogArticle;
}

export function BlogDetail({ article, category, onBack }: BlogDetailProps): JSX.Element {
    const [comment, setComment] = useState<string>("");

    return (
        <div className={styles["section"]}>
            <button className={styles["back-btn"]} onClick={onBack}><i className="fa fa-arrow-left" /> Back to Blog</button>

            <div style={{ maxWidth: "760px", margin: "0 auto" }}>
                <div className={styles["blog-cat"]} style={{ marginBottom: "0.75rem" }}>{category}</div>
                <div className={styles["blog-detail-title"]}>{article.title}</div>

                <div style={{ display: "flex", gap: "1.5rem", color: "var(--muted)", fontSize: "0.78rem", marginBottom: "1.5rem" }}>
                    {/* <span><i className="fa fa-pen" /> {post.author}</span> */}
                    <span><i className="fa fa-calendar" /> {Utils.fineDate(new Date(article.updated_at))}</span>
                    {/* <span><i className="fa fa-comment" /> {post.comments.length} comments</span> */}
                </div>

                {(!!article.extra_data?.featured_image) && (<img className={styles["blog-detail-banner"]} src={article.extra_data.featured_image} alt={article.title} loading="lazy" />)}

                <div className={styles["blog-detail-body"]} dangerouslySetInnerHTML={{ __html: Utils.markdownToHtml(article.content) }} />

                {/* COMMENTS */}
                {/* <div className={styles["comments-section"]}>
                    <div className={styles["comments-title"]}>COMMENTS ({post.comments.length})</div>

                    {post.comments.map(c => (
                        <div key={c.id} className={styles["comment-item"]}>
                            <img className={styles["comment-avatar"]} src={c.avatar} alt={c.author} />
                            <div style={{ flex: 1 }}>
                                <div className={styles["comment-author"]}>{c.author}</div>
                                <div className={styles["comment-date"]}>{c.date}</div>
                                <div className={styles["comment-text"]}>{c.text}</div>
                            </div>
                        </div>
                    ))}

                    <div className={styles["comment-form"]} style={{ marginTop: "2rem" }}>
                        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: "1rem", letterSpacing: "2px", color: "var(--gold)", marginBottom: "0.75rem" }}>
                            LEAVE A COMMENT
                        </div>
                        <textarea
                            className={`${styles["comment-form"]} ${styles["textarea"]}`}
                            placeholder="Share your thoughts..."
                            value={comment}
                            onChange={e => setComment(e.target.value)}
                        />
                        <button
                            className={styles["btn-primary"]}
                            style={{ marginTop: "0.75rem" }}
                            onClick={() => setComment("")}
                        >
                            Post Comment
                        </button>
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export function buildArticleView({ p, c, onSelect }: { p: IHostBlogArticle; c?: string; onSelect: (p: IHostBlogArticle) => void; }) {

    return (<div key={p.external_id} className={styles["blog-card"]} onClick={() => onSelect(p)}>
        {(!!p.extra_data?.featured_image) && (<img className={styles["blog-img"]} src={p.extra_data.featured_image} alt={p.title} loading="lazy" />)}
        <div className={styles["blog-body"]}>
            <div className={styles["blog-cat"]}>{c}</div>
            <div className={styles["blog-title"]}>{p.title}</div>
            <div className={styles["blog-excerpt"]}>{p.content.substring(0, 150)}...</div>
            <div className={styles["blog-meta"]}>
                <span><i className="fa fa-calendar" /> {Utils.fineDate(new Date(p.updated_at))}</span>
                {/* <span><i className="fa fa-comment" /> {p.comments.length} comments</span> */}
            </div>
        </div>
    </div>);
}

interface BlogProps {
    website: IHostWebsite;
}

function Blog(props: BlogProps) {

    const { website } = props;
    const omnehostService = OmneHostService.getInstance();
    const [categories, setCategories] = React.useState<IHostBlogCategory[]>();
    const [selectedArticle, setSelectedArticle] = React.useState<IHostBlogArticle>();
    const [articles, setArticles] = React.useState<ApiResponseData<IHostBlogArticle>>();
    const { page, setPage, category, setCategory, article, setArticle } = useSearchParams({ defaultInit: window.location.search, params: { page: 1, tab: "all", category: "", article: "" } });

    React.useEffect(() => {
        omnehostService.queryHostBlogCategories(website.host.external_id, {}).then(({ content }: SanitizedResponse<IHostBlogCategory>) => {
            setCategories(content);
        }).catch(BaseService.reportError);
    }, []);
    React.useEffect(() => {
        if (!article) {
            setSelectedArticle(undefined);
        }
    }, [article]);
    React.useEffect(fetchInformation, [omnehostService, page, category]);

    if (selectedArticle) {
        return (<BlogDetail article={selectedArticle} onBack={() => {
            setSelectedArticle(undefined);
            setArticle(undefined);
        }} />);
    }

    return (<>
        <div className={styles["section"]}>
            <div className={styles["sec-line"]} />
            <h1 className={styles["sec-title"]}>{website.host.name} <em>Blog</em></h1>
            <p className={styles["sec-sub"]}>News, highlights, behind the scenes and industry insights</p>

            <div className={styles["tabs"]}>
                {[{ name: "All", external_id: "" } as IHostBlogCategory, ...(categories ?? [])].map((c) => (
                    <button
                        key={c.external_id}
                        className={`${styles["tab-btn"]} ${category === c.external_id ? styles["active"] : ""}`}
                        onClick={() => setCategory(c.external_id)}
                    >
                        {c.name}
                    </button>
                ))}
            </div>

            {(!!articles?.content)
                ? ((articles.content && articles.content?.length > 0)
                    ? (<div className={styles["blog-grid"]}>
                        {articles.content!.map((p) => {
                            return buildArticleView({
                                p,
                                onSelect: (p) => {
                                    setSelectedArticle(p);
                                    setArticle(p.external_id);
                                },
                                c: categories?.find((c) => c.external_id === p.host_category_id)?.name,
                            });
                        })}
                    </div>)
                    : (Utils.emptyState()))
                : (Utils.loadingState())}

            <Paginator scheme={Scheme.LIGHT} style={{ marginTop: 50 }} rowsPerPage={articles?.size} totalRecords={articles?.total_elements} initialPage={parseInt("" + page)} onPageChange={(e) => {
                setPage(e.currentPage)
            }} template={{
                activePageLabel: () => "",
                nextPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-right")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
                previousPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-left")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
                lastPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-double-right")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
                firstPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-double-left")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
                pageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, (option.active ? styles["active"] : null))} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick}>{option.label}</button>),
            }} />
        </div>
    </>);

    function fetchInformation() {
        setArticles({});
        omnehostService.queryHostBlogArticles(website.host.external_id, {
            page,
            sort: "updated_at,DESC",
            host_category_id: category,
        }).then(({ apiResponse, content }: SanitizedResponse<IHostBlogArticle>) => {
            setArticles(apiResponse.data!);
            for (const v of (content ?? [])) {
                if (article && article === v.external_id) {
                    setSelectedArticle(v);
                    break;
                }
            }
        }).catch(BaseService.reportError);
    }

}

export default Blog;